import React from 'react';
import { Colors, PrimaryButton, Text } from 'library';
import { Box, Grid, styled, useMediaQuery } from '@mui/material';
import { track } from 'shared';
import PublicTeacherCard from './PublicTeacherCard';
import { ITeacher } from 'models';
import theme from 'theme';

const blurredWorkers = [
    {
        id: 1,
        name: 'Jasmine',
        pictureUrl: 'https://static.join-tandem.com/media/tandem_static/pexels-dziana-hasanbekava-7275385.jpg ',
        bio: "I'm a lead teacher with 5 years of experience. I worked with toddlers and preschoolers for 3 years and then spent some time working with infants. I'm passionate about helping children learn and grow.",
        credentials: {
            education: ["ECE-Related Associate's Degree"],
            experience: '5 years of childcare experience',
            highlights: ['Lead Teacher'],
            reviews: {
                average_score: 5.0,
                total_reviews: 3,
            },
        },
    },
    {
        id: 2,
        name: 'Helen',
        pictureUrl: 'https://static.join-tandem.com/media/tandem_static/pexels-gabby-k-5876695.jpg',
        bio: 'I have been working in childcare for 10 years. I love working with children and helping them learn and grow. I have a passion for teaching and learning.',
        credentials: {
            education: ["ECE-Related Bachelor's Degree"],
            experience: '10 years of childcare experience',
            highlights: ['Lead Teacher'],
            reviews: {
                average_score: 4.8,
                total_reviews: 10,
            },
        },
    },
    {
        id: 3,
        name: 'Jenny',
        pictureUrl: 'https://static.join-tandem.com/media/tandem_static/pexels-vinicius-wiesehofer-289347-1130626.jpg',
        bio: 'I have found that working with children is a very rewarding experience. I started working as a floater and loved seeing the children in all stages of development. I learned a lot about how to work with children of different age groups.',
        credentials: {
            education: ['CDA (Child Development Associate)'],
            experience: '3 years of childcare experience',
            highlights: ['Assistant Teacher'],
            reviews: {
                average_score: 4.5,
                total_reviews: 5,
            },
        },
    },
] as ITeacher[];

export const SeeMoreTeachers = ({ signUp, vettedWorkersCount }: { signUp: () => void; vettedWorkersCount: number }) => {
    const smDown = useMediaQuery(theme.breakpoints.down('md'));

    function shuffle(array: ITeacher[]) {
        return array.sort(() => Math.random() - 0.5);
    }

    return (
        <div style={{ position: 'relative', width: '100%' }}>
            <BlurredView />
            <SignupContainer smDown={smDown}>
                <Text variant="h1" textStyle={{ marginTop: 10 }}>
                    Don’t stop here—there are{' '}
                    <Text variant="h1" inline textStyle={{ color: Colors.mediumRed }}>
                        {vettedWorkersCount}+
                    </Text>{' '}
                    more teachers available in your area.
                </Text>
                <PrimaryButton
                    buttonStyle={{
                        width: 'fit-content',
                        height: 'fit-content',
                        marginTop: 20,
                        marginBottom: 10,
                    }}
                    onClick={() => {
                        track('Supported Region Customer Clicked Sign Up Button');
                        signUp();
                    }}
                >
                    Create Free Account
                </PrimaryButton>
            </SignupContainer>
            <Box
                sx={{
                    marginTop: 3,
                    padding: smDown ? 0 : 2,
                    display: 'grid',
                    gridTemplateColumns: {
                        xs: '1fr',
                        sm: '1fr',
                        md: 'repeat(2, 1fr)',
                        lg: 'repeat(2, 1fr)',
                        xl: 'repeat(3, 1fr)',
                    },
                    gap: '20px',
                    width: 'fit-content',
                    maxWidth: '100%',
                    mx: 'auto',
                    justifyItems: 'start',
                    '& > *': {
                        justifySelf: 'start',
                        width: 350,
                    },
                }}
            >
                {shuffle(blurredWorkers).map((worker, index) => (
                    <Box sx={{ width: '100%', maxWidth: '350px' }} key={worker.id}>
                        <PublicTeacherCard worker={worker} />
                    </Box>
                ))}
            </Box>
        </div>
    );
};

const BlurredView = styled('div')({
    position: 'absolute',
    top: 10,
    left: 0,
    right: 0,
    bottom: 0,
    backdropFilter: 'blur(10px)',
    zIndex: 1,
});

const SignupContainer = styled('div')<{ smDown: boolean }>(({ smDown }) => ({
    position: 'absolute',
    top: 140,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 2,
    backgroundColor: Colors.lightRed,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
    borderRadius: 16,
    width: smDown ? '90%' : '50%',
    height: 'fit-content',
    margin: '0 auto',
    border: `1px solid ${Colors.mediumRed}`,
    flexDirection: 'column',
}));
